import { Box, Typography } from '@mui/material';

export function NotFound() {
  return (
    <Box sx={{ width: '100%', textAlign: 'center', py: 8 }}>
      <Typography variant="h1" gutterBottom>
        404: Page not found
      </Typography>
      <Typography variant="body1" fontWeight={700}>
        Sorry, the page you are looking for does not exist or has been moved.
      </Typography>
      <img src="/tunedd-logo.png" alt="Page not found" height={200} />
    </Box>
  );
}

export default NotFound;
